<template>
  <li role="presentation">
    <header v-if="header" class="dropdown-header">{{ header }}</header>
    <ul class="list-unstyled" role="group"><slot/></ul>
  </li>
</template>

<script setup>
// Replaces bootstrap-vue's <b-dropdown-group> with the same markup (only the header prop is used).
defineOptions({
  name: 'BDropdownGroup',
})

defineProps({
  header: {
    type: String,
    default: null
  }
})
</script>
